<template>
  <transition name="el-zoom-in-center">
    <div class="content-wrapper">
      <!-- Main content -->
      <section class="content-noneheader">
        <!-- Default box -->
        <div class="box">
          <div class="box-header">
            <div class="box-header with-border">
              <el-breadcrumb separator="/">
                <el-breadcrumb-item>系统配置</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/config/configList' }">配置列表</el-breadcrumb-item>
                <el-breadcrumb-item>配置录入</el-breadcrumb-item>
              </el-breadcrumb>
            </div>
          </div>
          <div class="box-body">
            <div style="width: auto; text-align: center">
              <el-form ref="form" :model="config" label-width="100px" class="form-default">
                <el-input v-model="config.id" type="hidden"></el-input>
                <el-form-item label="配置分类">
                  <el-input v-model="config.category" v-bind:disabled="isDisabled"></el-input>
                </el-form-item>
                <el-form-item label="配置分类说明">
                  <el-input v-model="config.categoryLabel" v-bind:disabled="isDisabled"></el-input>
                </el-form-item>
                <el-form-item label="配置介绍">
                  <el-input v-model="config.configLabel" v-bind:disabled="isDisabled"></el-input>
                </el-form-item>
                <el-form-item label="配置值类型">
                  <el-input v-model="config.valueType"  v-bind:disabled="isDisabled"></el-input>
                </el-form-item>
                <el-form-item label="配置KEY">
                  <el-input v-model="config.configKey"  v-bind:disabled="isDisabled"></el-input>
                </el-form-item>
                <el-form-item label="配置VALUE">
                  <el-input v-model="config.value" clearable="true" ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="onSubmit">提交</el-button>
                  <el-button @click="onCancel">取消</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
          <!-- /.box-body -->
        </div>
        <!-- /.box -->
      </section>
      <!-- /.content -->
    </div>
  </transition>
</template>

<script>
  export default {
    name: 'ConfigModify',
    data: function () {
      return {
        createOpt: true, // 是否新建操作
        config: {
          id: '',
          configKey: '',
          category: '',
          categoryLabel: '',
          configLabel: '',
          value: '',
          valueType: ''
        },
        isDisabled: false
      }
    },
    mounted: function () {
      // 编辑的时候会有有id参数
      let id = this.$route.query.id
      if (id) {
        this.createOpt = false
        this.isDisabled = true
        this.axios.get('/admin/config/find', {params: {id: id}})
          .then(resp => { // 装载对象
            this.config = resp.data.data
          }).catch(resp => {
          // TODO 出错提示
        })
      }
    },
    methods: {
      onSubmit: function () { //  TODO 录入检查方案
        this.axios.post('/admin/config/save', this.config)
          .then(resp => { // 保存成功跳回列表页面
            if (resp.data.code === 200) {
              if (!this.createOpt) {
                this.$message({
                  type: 'success',
                  message: '修改成功!'
                })
              } else {
                this.$message({
                  type: 'success',
                  message: '添加成功!'
                })
              }
              this.$router.replace('/config/configList')
            } else {
              this.$message({
                type: 'error',
                message: resp.data.message
              })
            }
          }).catch(resp => {
          this.$message({
            type: 'error',
            message: '请求服务器出错'
          })
        })
      },
      onCancel: function () {
        this.$router.replace('/config/configList')
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ConfigModify.vue?75631896